import React, { useState,useEffect,useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import './css/eventform.css';
import EventCreationStep from "./EventCreationStep.js"
import ConfirmDialog from './components/ConfirmDialog.js';
import { Menu, MenuItem, IconButton, ListItemIcon, ListItemText } from "@mui/material";
import { FaEdit,FaEye,FaCopy, FaPlusCircle,FaAngleDown,FaTrashAlt } from 'react-icons/fa'; // icons
import { API_URL_BASE } from './config';

function EventHome() {
	const [refreshKey, setRefreshKey] = useState(0); // triggers re-run of useEffect
	const [showEventform, setShowEventForm] = useState(false);
	const [showDialog, setShowDialog] = useState(false);
	const [events, setEvents] = useState([]);
	const [pastevents, setPastEvents] = useState([]);
	const [anchorEl, setAnchorEl] = useState(null);
	const [selectedEvent, setSelectedEvent] = useState(null);
	const [loading, setLoading] = useState(true);
	const [token, setToken] = useState('');
	const [openDropdownId, setOpenDropdownId] = useState(null);
	const [sortConfig, setSortConfig] = useState({ key: 'startdatetime', direction: 'desc' });
	const [pastSortConfig, setPastSortConfig] = useState({ key: 'startdatetime', direction: "desc" });
	const dropdownRef = useRef(null);
	const [message, setMessage] = useState('');
	const navigate = useNavigate();	

	const toggleDropdown = (eventId) => {
	  setOpenDropdownId(prev => (prev === eventId ? null : eventId));
	};
	
	const open = Boolean(anchorEl);

	const handleMenuOpen = (event, pastevents) => {
	  setAnchorEl(event.currentTarget);
	  setSelectedEvent(pastevents);
	};

	const handleMenuClose = () => {
	  setAnchorEl(null);
	};
	
	// Step 1: Set token from localStorage
	useEffect(() => {
	  const storedToken = localStorage.getItem('token');
	  if (storedToken) {
	    setToken(storedToken);
	  } else {
	    // Optional: redirect to login or show fallback
	    console.warn("No token found in localStorage");
	    setLoading(false);
		navigate("/");
	  }
	}, ["token"]);
	
	// Step 2: Fetch events when token is set
	 useEffect(() => {
	   if (!token) return; // Don't run if token is not ready

	   fetch(API_URL_BASE + '/ticket.json', {
	     method: 'POST',
	     headers: {
	       'Content-Type': 'application/json',
	     },
	     body: JSON.stringify({
	       fetchevents: {
	           token: token
	       }
	     }),
	   })
	     .then((res) => {
	       if (!res.ok) throw new Error(`Server error: ${res.status}`);
	       return res.json();
	     })
	     .then((result) => {
			//setEvents(result.events.events);
			//setPastEvents(result.events.events.filter(e => new Date(e.startdatetime).getTime() < new Date()) || []);
			//setEvents(result.events.events.filter(e => new Date(e.startdatetime).getTime() >= new Date()) || []);
			
			// Use start of today so events remain "upcoming" for the full day they start
			const startOfToday = new Date();
			startOfToday.setHours(0, 0, 0, 0);
			setPastEvents(result.events.events.filter(e => new Date(e.startdatetime).getTime() < startOfToday.getTime()) || []);
			setEvents(result.events.events.filter(e => new Date(e.startdatetime).getTime() >= startOfToday.getTime()) || []);

	     })
	     .catch((err) => {
	       console.error("Fetch error:", err);
	     })
	     .finally(() => {
	       setLoading(false);
	     });

	 }, [token,refreshKey]); // 🔁 Runs whenever token or refreshkey is updated
	
	 // Close dropdown on outside click
	 useEffect(() => {
	   const handleClickOutside = (e) => {
	     if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
	       setOpenDropdownId(null);
	     }
	   };

	   document.addEventListener('mousedown', handleClickOutside);
	   return () => {
	     document.removeEventListener('mousedown', handleClickOutside);
	   };
	 }, []);
	
	const handleCreateNewEvent = () => {
	   // setShowEventForm(true);
		navigate('/dashboard/events/new');
	};
	
	const onEdit = (row) => {
	  navigate(`/dashboard/events/update`,{state:{event: row}});
	};
	
	const onView = (row) => {
		navigate(`/dashboard/events/${row.eventid}`);
	};
	
	const onCopy = (row) => {
		handleCreateNewEvent();
	};
	
	const onDelete = (row) => {
		 setShowDialog(true);
		 setSelectedEvent(row);
	}
	
	
	const handleConfirmDelete =  async (e) => {
		console.log("Deleting event:", selectedEvent);
		setShowDialog(false);
		e.preventDefault();
		try {
		const response = await fetch(API_URL_BASE + '/ticket.json', {
					    	method: 'POST',
					    	headers: {
					      	'Content-Type': 'application/json',
					    	},
					    	body: JSON.stringify(					{
								deleteevent : {
									token: token,
									id  : selectedEvent.eventid}
							  })
					  	});
						

		// Check if fetch succeeded (status not blocked)
		if (!response.ok) {
		  throw new Error(`Server error: ${response.status}`);
		}

		const result = await response.json();
		console.log(result);

		if (result && result.message == 'DELETED') {
		  setRefreshKey(oldKey => oldKey + 1);
		} else {
		  throw new Error("Event Deletion failed");
		}

		} catch(e){
			setMessage(e.message || " An unexpected error occurred with Deleting event!!");
		}	
		};
	  
		
		const handleSort = (key,table) => {
			if (table === "upcoming") {
				
			  let direction = 'asc';
			  if (sortConfig.key === key && sortConfig.direction === 'asc') {
			    direction = 'desc';
			  }
		  		setSortConfig({ key, direction });
			} else if(table === 'past'){
				let direction = 'asc';
						  if (pastSortConfig.key === key && pastSortConfig.direction === 'asc') {
						    direction = 'desc';
						  }
					  	setPastSortConfig({ key, direction });
			}
		};
		
		
			const sortedEvents = [...events].sort((a, b) => {
			  if (!sortConfig.key) return 0;
			  const aVal = a[sortConfig.key];
			  const bVal = b[sortConfig.key];
	
			  if (aVal < bVal) return sortConfig.direction === 'asc' ? -1 : 1;
			  if (aVal > bVal) return sortConfig.direction === 'asc' ? 1 : -1;
			  return 0;
			});
		

			const sortedPastEvents = [...pastevents].sort((a, b) => {
			  if (!pastSortConfig.key) return 0;
			  const aVal = a[pastSortConfig.key];
			  const bVal = b[pastSortConfig.key];
	
			  if (aVal < bVal) return pastSortConfig.direction === 'asc' ? -1 : 1;
			  if (aVal > bVal) return pastSortConfig.direction === 'asc' ? 1 : -1;
			  return 0;
			});
		


    return (
	<div>
		<section className="main-content">
		<p className="error-text">{message}</p>
		{showDialog && (
		        <ConfirmDialog
		          title="Confirm Delete"
		          message={`Are you sure you want to delete "${selectedEvent.name}"?`}
		          onConfirm={handleConfirmDelete}
		          onCancel={() => setShowDialog(false)}
		        />
		      )}
			  <Menu
			    anchorEl={anchorEl}
			    open={open}
			    onClose={handleMenuClose}
			    anchorOrigin={{
			      vertical: "bottom",
			      horizontal: "right",
			    }}
			    transformOrigin={{
			      vertical: "top",
			      horizontal: "right",
			    }}
			  >
			    <MenuItem
			      onClick={() => {
			        onView(selectedEvent);
			        handleMenuClose();
			      }}
			    >
			      <ListItemIcon>
			        <FaEye size={14} />
			      </ListItemIcon>
			      <ListItemText>View</ListItemText>
			    </MenuItem>

			    <MenuItem
			      onClick={() => {
			        onCopy(selectedEvent);
			        handleMenuClose();
			      }}
			    >
			      <ListItemIcon>
			        <FaCopy size={14} />
			      </ListItemIcon>
			      <ListItemText>Copy</ListItemText>
			    </MenuItem>

			    <MenuItem
			      onClick={() => {
			        onDelete(selectedEvent);
			        handleMenuClose();
			      }}
			    >
			      <ListItemIcon>
			        <FaTrashAlt size={14} />
			      </ListItemIcon>
			      <ListItemText>Delete</ListItemText>
			    </MenuItem>
			  </Menu>

			  	  
		{!showEventform ? (
		<div>
			<button className="btn create-btn" onClick={handleCreateNewEvent}>
				<FaPlusCircle style={{paddingRight:'10px'}}/> Create New Event 
			</button>
		     <h2>Upcoming Events</h2>
			 {loading ? (
				<p> Loading Events ....</p>
			  ) : (events.length > 0 ) ? 
			  (
			<div>
			<div className="table-responsive">	 		     
		     <table className="events-table">
		         <thead>
		             <tr>
					 <th></th>
					 <th></th>
					 <th onClick={() => handleSort('name','upcoming')}>Event Name {sortConfig.key === 'name' && (sortConfig.direction === 'asc' ? '▲' : '▼')}</th>
					 <th onClick={() => handleSort('startdatetime','upcoming')}>Event Start {sortConfig.key === 'startdatetime' && (sortConfig.direction === 'asc' ? '▲' : '▼')}</th>
					 <th onClick={() => handleSort('enddatetime','upcoming')}>Event End {sortConfig.key === 'enddatetime' && (sortConfig.direction === 'asc' ? '▲' : '▼')}</th>
		             </tr>
		         </thead>
		         <tbody>
		             {sortedEvents.map(event => (
		                 <tr key={event.hjid}>
							 <td>
							   <FaEdit
							     style={{ 
							 	cursor: event.status === 'NEW' ? 'pointer' : 'not-allowed',
							 	color: event.status === 'NEW' ? '#1E3A8A' : '#9CA3AF' // blue vs gray 
							   }}
							   onClick={() => {
							     if (event.status === 'NEW') {
							       onEdit(event);
							     }
							   }}
							     title={event.status === 'NEW' ? "Edit Event" : "Published events cannot be edited"}
							   />
							 </td>	
							 <td>
							   <FaEye
							     style={{ cursor: 'pointer', color: '#1E3A8A' }}
							     onClick={() => onView(event)}
							     title="View Event"
							   />
							 </td>								 					 
		                     <td>{event.name}</td>
		                     <td>{new Date(event.startdatetime).toLocaleString()}</td>
							 <td>{new Date(event.enddatetime).toLocaleString()}</td>						 
		                 </tr>
		             ))}
		         </tbody>
		     </table>
			 </div>
			 </div>
			 )
			 : (
			 	 <p> No Upcoming Events....  </p>
			 ) }
			 
			 {loading ? (
			 <p> Loading Past Events ....</p>
			  ) : (pastevents.length > 0 ) ? 
			  (	 
			 <div>	
			 <div className="table-responsive">
			 	<h2>Past Events</h2>
				<table className="events-table">
				    <thead>
				        <tr>
							<th></th>
							<th onClick={() => handleSort('name','past')}>Event Name {pastSortConfig.key === 'name' && (pastSortConfig.direction === 'asc' ? '▲' : '▼')}</th>
				            <th onClick={() => handleSort('startdatetime','past')}>Event Start {pastSortConfig.key === 'startdatetime' && (pastSortConfig.direction === 'asc' ? '▲' : '▼')}</th>
						 	<th onClick={() => handleSort('enddatetime','past')}>Event End {pastSortConfig.key === 'enddatetime' && (pastSortConfig.direction === 'asc' ? '▲' : '▼')}</th>
				        </tr>
				    </thead>
				    <tbody>
				        {sortedPastEvents.map(pastevents => (
				            <tr key={pastevents.hjid}>
								<td className="action-cell">
								  <IconButton
								    onClick={(e) => handleMenuOpen(e, pastevents)}
								    size="small"
								 sx={{
								     p: 0.5,      // reduce padding (default is 1)
								     width: 28,
								     height: 28
								   }}
								  >
								    <FaAngleDown size={14} style={{ color: "#1E3A8A" }} />
								  </IconButton>
								</td>	
				                <td>{pastevents.name}</td>
				                <td>{new Date(pastevents.startdatetime).toLocaleString()}</td>
							 <td>{new Date(pastevents.enddatetime).toLocaleString()}</td>					 
				            </tr>
				        ))}
				    </tbody>
				</table>				
			 </div>
			 </div>
			) : null }
		 </div>
		 ): null}

		{showEventform ? ( <EventCreationStep/>) : null }
		</section>
        </div>
    );
}

export default EventHome;
